import { render, staticRenderFns } from "./TrainingRating.vue?vue&type=template&id=3cea66b5&scoped=true"
import script from "./TrainingRating.vue?vue&type=script&lang=js"
export * from "./TrainingRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cea66b5",
  null
  
)

export default component.exports